import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LoginAuthContext } from "Context/Authentication/LoginAuth";

const useButtonConfig = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isLoggedIn, isVerified, isAuthenticated, allowedCourses } =
    useContext(LoginAuthContext);

  if (!isLoggedIn) {
    return {
      text: t("cta.start_in_2min"),
      subtitle: t("cta.start_in_2min_sub"),
      action: () => navigate("/register"),
    };
  } else if (!isVerified) {
    return {
      text: t("cta.finish_in_1min"),
      subtitle: t("cta.finish_in_1min_sub"),
      action: () => navigate("/verify-email"),
    };
  } else if (isAuthenticated || allowedCourses?.length > 0) {
    return {
      text: t("cta.continue_learning"),
      subtitle: null,
      action: () => navigate("/my-courses"),
    };
  } else {
    return {
      text: t("cta.start_in_1min"),
      subtitle: t("cta.start_in_1min_sub"),
      action: () => navigate("/plans"),
    };
  }
};

export default useButtonConfig;
